// extracted by mini-css-extract-plugin
export default {"textLogo":"PMSLogo_textLogo__iqyFi"};